import { Card, type CardProps } from "@clipboard-health/ui-components";
import { mergeSxProps } from "@clipboard-health/ui-components";

interface ShiftCardWrapperProps extends CardProps {
  isUrgent?: boolean;
}

export function ShiftCardWrapper(props: ShiftCardWrapperProps) {
  const { isUrgent = false, variant = "quaternary", outlined = true, sx, ...restProps } = props;

  return (
    <Card
      variant={variant}
      outlined={isUrgent || outlined}
      sx={mergeSxProps(
        (theme) => ({
          minHeight: theme.size?.shiftCard.minHeight,
          borderColor: isUrgent ? theme.palette.shift?.urgent.border : undefined,
        }),
        sx
      )}
      {...restProps}
    />
  );
}
